import { Analysis } from '../models/Analysis';
import { Folder } from '../models/Folder';
import { AnalysisPage } from '../models/AnalysisPage';
import { AnalysisType } from '../models/AnalysisType';
import { AnalysisForm } from '../models/AnalysisForm';
import { SearchUser } from '../../user-admin/user/models/SearchUser';
import { GDMSData } from '../header-data/header-optional-data/header-gdms-popup/models/GDMSData';
import { initialLockState, LockState } from '../popups/lock-control-popup/model/LockState';
import { PlannedTvgTimeReport } from '../../print/models/planned-tvg-time-report.model';

export interface AnalysisState {
    analysis: Analysis | null;
    loadingAnalysis: boolean;
    loadingAnalysisCounter?: number;
    loadingPrintAnalysis: boolean;
    templateFolders: Folder[];
    loadingTemplateFolders: boolean;
    selectedAnalysisPage: AnalysisPage | null;
    showDialogOnGroupAnalysisSave: boolean;
    showFooterBarOverviewMenu: boolean;
    showOperatingInstructions: boolean;
    pendingOpenOperatingInstructions: boolean;
    setTrainingValidation: boolean;
    analysisTypes: AnalysisType[];
    analysisForms: AnalysisForm[];
    users: SearchUser[];
    loadingSearchUsersTable: boolean;
    gdmsData: GDMSData | null;
    loadingGDMSModal: boolean;
    gdmsDocumentUrl: string | null;
    lockState: LockState;
    qrCodePdfUrl?: string | null;
    loadingPlannedTvgTimeReport?: boolean;
    plannedTvgTimeReport?: PlannedTvgTimeReport | null;
    showLeaveAnalysisConfirmation?: boolean;
}

export const initialState: AnalysisState = {
    analysis: null,
    loadingAnalysis: false,
    loadingPrintAnalysis: false,
    loadingAnalysisCounter: 0,
    templateFolders: [],
    loadingTemplateFolders: false,
    selectedAnalysisPage: null,
    showDialogOnGroupAnalysisSave: false,
    showFooterBarOverviewMenu: false,
    showOperatingInstructions: false,
    pendingOpenOperatingInstructions: false,
    setTrainingValidation: false,
    analysisTypes: [],
    analysisForms: [],
    users: [],
    loadingSearchUsersTable: false,
    gdmsData: null,
    loadingGDMSModal: false,
    gdmsDocumentUrl: null,
    lockState: initialLockState,
    loadingPlannedTvgTimeReport: false,
    plannedTvgTimeReport: null,
    showLeaveAnalysisConfirmation: false
};

export const featureKey = 'analysisModule';
